<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <h3>
        {{$route.meta.title}}
      </h3>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>财务管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="withdraw-option flex-center">
      <el-upload :on-change="onChangeFile_bank"
                 class="arc-upload"
                 action=""
                 :show-file-list="false"
                 accept=".xlsx,.xls"
                 :auto-upload="false">
        <el-button slot="trigger"
                   size="small"
                   class="arc-upload-button"
                   type="primary">批量提现（银行卡）
        </el-button>
      </el-upload>

      <el-upload :on-change="onChangeFile_alipay"
                 class="arc-upload"
                 action=""
                 :show-file-list="false"
                 accept=".xlsx,.xls"
                 :auto-upload="false">
        <el-button slot="trigger"
                   size="small"
                   class="arc-upload-button"
                   type="primary">批量提现（支付宝）
        </el-button>
      </el-upload>

      <el-upload :on-change="onChangeFile_bankAll"
                 class="arc-upload"
                 action=""
                 :show-file-list="false"
                 accept=".xlsx,.xls"
                 :auto-upload="false">
        <el-button slot="trigger"
                   size="small"
                   class="arc-upload-button"
                   type="primary">批量提现（银行卡 全部）
        </el-button>
      </el-upload>

      <el-upload :on-change="onChangeFile_alipayAll"
                 class="arc-upload"
                 action=""
                 :show-file-list="false"
                 accept=".xlsx,.xls"
                 :auto-upload="false">
        <el-button slot="trigger"
                   size="small"
                   class="arc-upload-button"
                   type="primary">批量提现（支付宝 全部）
        </el-button>
      </el-upload>
    </div>

    <layout-panel :show-header="true">
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <el-table ref="multipleTable"
                :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%">
        <el-table-column prop="id"
                         label="批量任务ID"
                         width="100"></el-table-column>
        <el-table-column prop="display_name"
                         label="上传文件">
          <template slot-scope="scope">
            <span style="cursor:pointer;color:rgb(88,157,248)"
                  @click="onDownSourceFile(scope.row.id)">{{scope.row.display_name}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="number"
                         label="类别"
                         width="200">
          <template slot-scope="scope">
            <span>批量提现</span>
            <span>{{options.number[scope.row.number] ? `（${options.number[scope.row.number]}）` : ''}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="admin_name"
                         label="发起者"
                         width="70"></el-table-column>

        <el-table-column prop="created_at"
                         label="上传时间"
                         min-width="120"></el-table-column>
        <el-table-column prop="success_count"
                         label="任务进度">
          <template slot-scope="scope">
            <sj-progress
              :percentages="taskBatchPercentage(scope.row)"
              :status="taskBatchStatus(scope.row)"
              :stroke-width="18"></sj-progress>
            <span>成功: </span>
            <span>{{scope.row.success_count}}</span>
            <span>失败: </span>
            <span>{{scope.row.error_count}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="status"
                         label="状态"
                         width="80">
          <template slot-scope="scope">
            <span v-for="item in status"
                  v-if="item.value === scope.row.status">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="150">
          <template slot-scope="scope">
            <el-button type="text"
                       size="mini"
                       @click="onDownResultFile(scope.row.id)">下载提现结果
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>


<script>
import table from '@core/mixins/table'
import downloadJS from 'downloadjs'
import SjProgress from '@/components/sj-progress'
import taskBatchMixins from '@/views/task-batch/task-batch.mixins'


export default {
  mixins: [table, taskBatchMixins],
  components: {SjProgress},
  data () {
    return {
      multipleSelection: [],
      table: [],
      pagination: {
        current_page: 1,
        per_page: 20,
        total: 0,
      },
      search: {
        task_type: [207],
        number: this.$route.params.number || '',
      },
      options: {
        number: {
          '-1': '未知',
          '2': '银行卡',
          '3': '银行卡 全部',
          '4': '支付宝',
          '5': '支付宝 全部',
        },
      },
    }
  },
  created () {
  },
  computed: Vuex.mapState({
    status: state => state.taskBatch.status,
  }),
  methods: {
    ...Vuex.mapActions({}),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      return request.page('batchWithdrawList', params)
    },

    onDownSourceFile (id) {
      this.$confirm('确认下载文件?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        downloadJS(request.items.downSourceFile(id))
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '下载已取消',
        })
      })
    },

    onDownResultFile (id) {
      this.$confirm('确认下载提现结果?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        downloadJS(request.items.downExportFile(id))
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '下载已取消',
        })
      })
    },

    onCheckFile (file) {
      let isLt10M = file.raw.size / 1024 / 1024 < 10
      if (!isLt10M) {
        this.$message.error('大小不能超过10MB!')
        return false
      }

      return true
    },

    onChangeFile_bank (file, fileList) {
      if (!this.onCheckFile(file)) {
        fileList.splice(0)
        return
      }
      fileList.splice(0, fileList.length - 1)
      this.onUploadFile(file.raw, 2)
    },
    onChangeFile_bankAll (file, fileList) {
      if (!this.onCheckFile(file)) {
        fileList.splice(0)
        return
      }
      fileList.splice(0, fileList.length - 1)
      this.onUploadFile(file.raw, 3)
    },
    onChangeFile_alipay (file, fileList) {
      if (!this.onCheckFile(file)) {
        fileList.splice(0)
        return
      }
      fileList.splice(0, fileList.length - 1)
      this.onUploadFile(file.raw, 4)
    },
    onChangeFile_alipayAll (file, fileList) {
      if (!this.onCheckFile(file)) {
        fileList.splice(0)
        return
      }
      fileList.splice(0, fileList.length - 1)
      this.onUploadFile(file.raw, 5)
    },

    onUploadFile (file, type) {
      let data = new FormData()
      data.append('file', file)
      data.append('withdraw_type', type)
      return request.common('submitBatchWithdraw', data).then((res) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
        this.onSearch()
      })
    },
  },
}
</script>


<style lang="scss"
       scoped>
.withdraw-option {
  justify-content: flex-start;
  align-items: flex-start;
  margin: 0 0 20px;

  .arc-upload {
    flex-shrink: 0;
    flex-grow: 0;
    margin: 5px 10px 5px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/finance/pages/BatchWithdrawTable.vue